/**
 * ボタングループを初期化
 *
 * Metronicのボタングループ（[data-kt-buttons="true"]）に対して：
 * 1. クリック時のactive状態トグル
 * 2. キーボードナビゲーション対応（tabindex + Enter/Space）
 */
export default function initializeButtonGroups() {
  const buttonsGroup = document.querySelectorAll('[data-kt-buttons="true"]');

  buttonsGroup.forEach(group => {
    if (group.getAttribute("data-kt-initialized") === "1") {
      return;
    }

    const selector = group.hasAttribute('data-kt-buttons-target')
      ? group.getAttribute('data-kt-buttons-target')
      : '.btn';

    // クリック時のactive状態トグル（イベント委譲）
    group.addEventListener('click', (e) => {
      const target = e.target.closest(selector);
      if (!target) return;

      const activeButtons = group.querySelectorAll(selector);
      activeButtons.forEach(btn => btn.classList.remove('active'));
      target.classList.add('active');
    });

    /**
     * キーボードナビゲーション対応
     * - tabindex="0"でラベル要素をフォーカス可能に
     * - 内部のinput要素はtabindex="-1"でタブオーダーから除外
     *   （CSS clip: rect(0,0,0,0)で非表示だが、デフォルトでフォーカス可能なため）
     * - Enter/Spaceキーでクリックをシミュレート
     *   → activeクラス更新 + input checked + changeイベント発火
     */
    const buttons = group.querySelectorAll(selector);
    buttons.forEach(btn => {
      btn.setAttribute('tabindex', '0');

      // 内部のinput要素をタブオーダーから除外（2回Tab問題の解決）
      const input = btn.querySelector('input');
      if (input) {
        input.setAttribute('tabindex', '-1');
      }

      btn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          btn.click();
        }
      });
    });

    group.setAttribute("data-kt-initialized", "1");
  });
}
